import panditLogo from '@/assets/dopuja-pandit-app.webp';
import doPujaLogo from '@/assets/dopuja-app.webp';

export type PromotionMessage = { id: string; category: string; text: string; enabled: boolean };
export type AppPromotionSettings = {
  enabled: boolean;
  speedPixelsPerSecond: number;
  openingMessage: string;
  messages: PromotionMessage[];
  storeUrls: {
    panditGooglePlay: string | null;
    panditAppStore: string | null;
    doPujaGooglePlay: string | null;
    doPujaAppStore: string | null;
  };
};

export const appPromotionLogos = {
  pandit: { src: panditLogo, name: 'DoPuja Purohit' },
  doPuja: { src: doPujaLogo, name: 'DoPuja' },
} as const;

export const promotionCategories = [
  'Pundit Booking — ఇంట్లో పూజలు', 'Digital Puja', 'Temple Puja', 'Astrology',
  'AI Astrology / Reports', 'Nitya Puja', 'Umas Aura',
] as const;

const campaignText: { category: string; lines: string[] }[] = [
  { category: promotionCategories[0], lines: [
    'ఇంట్లో పూజ చేయించాలా? పురోహితుల కోసం వెతుకుతున్నారా? — Do Puja ఉందిగా!',
    'ముహూర్తం దగ్గరపడుతోంది… పురోహితులు ఇంకా దొరకలేదా? — Do Puja ఉందిగా!',
    'మీ ఇంటి శుభకార్యానికి సరైన పురోహితులు కావాలా? — Do Pujaలో Book చేయండి.',
    'గృహప్రవేశమా? సత్యనారాయణ వ్రతమా? — పురోహితులు ఒక్క Appలోనే.',
    'పూజ చేయించాలని ఉందా? ఎవరిని పిలవాలో తెలియడం లేదా? — Do Puja ఉందిగా!',
    'పూజ నుంచి పురోహితుల వరకు… ఇక వెతకాల్సిన పని లేదు.',
    'మీ ఇంట్లో శాస్త్రోక్తంగా పూజ జరగాలంటే — Do Puja.',
    'మీ పూజకు సరైన పురోహితులు… ఇప్పుడు మీ ఫోన్‌లోనే.',
  ] },
  { category: promotionCategories[1], lines: [
    'పూజకు వెళ్లలేకపోతున్నారా? మీ పేరుతో పూజ జరగాలా? — Do Puja ఉందిగా!',
    'మీరు ఎక్కడున్నా… మీ సంకల్పంతో పూజ జరగాలి.',
    'దూరం అడ్డంకి కాకూడదు… దైవారాధన ఆగకూడదు.',
    'మీ పేరుతో పూజ… మీ ఫోన్‌లోనే దర్శనం.',
    'పూజలో పాల్గొనలేకపోతున్నారా? Digital Puja ఉందిగా!',
    'సంకల్పం మీది… పూజ శాస్త్రోక్తంగా మాది.',
    'ఎక్కడి నుంచైనా భక్తితో పూజలో భాగం అవ్వండి.',
    'మీ పేరుతో పూజ… పూజ పూర్తయ్యాక Video పొందండి.',
  ] },
  { category: promotionCategories[2], lines: [
    'మీకు ఇష్టమైన ఆలయంలో మీ పేరుతో పూజ జరగాలా? — Do Puja ఉందిగా!',
    'ఆలయానికి వెళ్లలేకపోతున్నారా? మీ సంకల్పం మాత్రం చేరుతుంది.',
    'మీ కుటుంబం పేరుతో ఆలయ పూజ చేయించండి — Do Puja ద్వారా.',
    'దూరంలో ఉన్న ఆలయం… ఇప్పుడు మీకు మరింత దగ్గరగా.',
    'దైవ దర్శనం దూరమైనా… దైవ సేవ దూరం కాదు.',
    'మీ పేరుతో Temple Puja… వివరాలు మీ ఫోన్‌లో.',
    'ప్రత్యేక రోజున ప్రత్యేక ఆలయంలో పూజ చేయించాలా? — Do Puja ఉందిగా!',
    'ఆలయ పూజను సులభంగా Book చేయండి — Do Puja.',
  ] },
  { category: promotionCategories[3], lines: [
    'జీవితంలో ఏ నిర్ణయం తీసుకోవాలో అర్థం కావడం లేదా? — Astrologerని అడగండి.',
    'Career? Marriage? Finance? — మీ జాతకం ఏమంటుందో తెలుసుకోండి.',
    'మీ ప్రశ్నకు జ్యోతిష్య మార్గదర్శనం కావాలా? — Do Puja ఉందిగా!',
    'మీ జాతకంలో ఉన్న యోగాలు మీకు తెలుసా?',
    'మీ జీవితంలో మంచి సమయం ఎప్పుడు? — మీ జాతకాన్ని తెలుసుకోండి.',
    'ఒక్క జాతకం… ఎన్నో ప్రశ్నలకు మార్గదర్శనం.',
    'Astrologerతో Talk లేదా Chat — ఇప్పుడు Do Pujaలో.',
    'మీ గ్రహస్థితులు ఏమి సూచిస్తున్నాయో తెలుసుకోండి.',
  ] },
  { category: promotionCategories[4], lines: [
    'మీ జాతకం గురించి వెంటనే తెలుసుకోవాలా? — AI Astrology ఉందిగా!',
    'మీ Horoscope Report… ఇప్పుడు మీ ఫోన్‌లోనే.',
    'Career నుంచి Rajayoga వరకు — మీ జాతకాన్ని వివరంగా తెలుసుకోండి.',
    'మీ రోజువారీ రాశి/జాతక మార్గదర్శనం WhatsAppలో కావాలా?',
    'జాతకం చేతిలో ఉంది… దాని అర్థం తెలియదా? — Do Pujaని అడగండి.',
    'మీ Birth Details ఇవ్వండి… మీ Astrology Report పొందండి.',
  ] },
  { category: promotionCategories[5], lines: [
    'మీ షాపులో రోజూ దీపం వెలగాలా? — Nitya Puja ఉందిగా!',
    'Business చూసుకోవడం మీ పని… రోజువారీ పూజ బాధ్యత మాది.',
    'ఆఫీస్‌లో ప్రతిరోజూ పూజ జరగాలని కోరుకుంటున్నారా?',
    'షాప్, ఆఫీస్, హాస్పిటల్ — ప్రతిరోజూ దైవారాధన కోసం Nitya Puja.',
    'మీరు Busyగా ఉన్నా… మీ నిత్య పూజ ఆగాల్సిన అవసరం లేదు.',
    'రోజూ పూజ కోసం రోజూ ఆలోచించకండి — Nitya Puja Book చేయండి.',
  ] },
  { category: promotionCategories[6], lines: [
    'అసలైన Rudraksha కోసం వెతుకుతున్నారా? — Umas Aura ఉందిగా!',
    'Gemstone కొనాలి… కానీ genuineదో కాదో సందేహమా? — Umas Aura.',
    'మీ జాతకానికి సరైన రత్నం ఏదో తెలుసా?',
    'Rudraksha నుంచి Gemstones వరకు — ఆధ్యాత్మిక products ఒకే చోట.',
    'ధరించడం మాత్రమే కాదు… సరైనదాన్ని ఎంచుకోవడం ముఖ్యం.',
    'పూజ నుంచి జ్యోతిష్యం వరకు… ఆలయం నుంచి ఆధ్యాత్మిక products వరకు — అన్నీ ఒకే Appలో. Do Puja.',
  ] },
];

export const defaultAppPromotionSettings: AppPromotionSettings = {
  enabled: true,
  speedPixelsPerSecond: 42,
  openingMessage: 'పురోహితుల కోసం వెతుకుతున్నారా? — Do Puja ఉందిగా!',
  messages: campaignText.flatMap(({ category, lines }, categoryIndex) =>
    lines.map((text, index) => ({ id: `campaign-${categoryIndex + 1}-${index + 1}`, category, text, enabled: true })),
  ),
  storeUrls: { panditGooglePlay: null, panditAppStore: null, doPujaGooglePlay: null, doPujaAppStore: null },
};
